import { useTranslation } from "react-i18next";
import Magazines from "./Magazines";
import Books from "./Books";
import SEO from "../common/SEO";

const MagazinesBooks = ({ renderBody }) => {
  const { i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Magazines & Books" : "Riviste & Libri";
  const desc = isEnglish
    ? "Magazine features, cover stories, and historical books published about the Nuova Orchestra da Camera Ferruccio Busoni."
    : "Copertine, articoli di riviste specializzate (Amadeus, Suonare News) e volumi celebrativi sull'Orchestra Busoni.";

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section">
        <Magazines renderBody={renderBody} />
        <Books renderBody={renderBody} />
      </section>
    </>
  );
};

export default MagazinesBooks;
